<div class="content">
  <div class="row items-push">
    <div class="col-sm-12 text-left">
      <ol class="breadcrumb push-10-t">
        <li><a [routerLink]="['/']">Inicio</a></li>
        <li>
          <span class="link-effect">Autorizar Accesos</span>
        </li>
      </ol>
    </div>
  </div>
</div>
<div class="content">
  <div class="block">
    <div class="block-header">
      <h3 class="block-title">Autorizar Accesos</h3>
    </div>

    <!-- FILTROS -->
    <div class="block-content">
      <div class="form-horizontal">
        <div class="form-group">
          <label class="col-md-2 control-label">Compañía:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label> Seleccione: </mat-label>
              <mat-select matSelect [(ngModel)]="modelFilter.idCompania" [disabled]="listaCompanias.length == 1" (selectionChange)="companiaChanged()">
                <mat-option *ngFor="let company of listaCompanias" [value]="company.idCompania">
                  {{ company.nombre }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <label class="col-md-2 control-label">Sede:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label> Seleccione </mat-label>
              <mat-select matSelect [(ngModel)]="modelFilter.sedes" name="sedes" multiple>
                <mat-option *ngFor="let item of listaSedes; index as i" [value]="item.idSede">{{ item.nombre
                  }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="form-group">
          <label class="col-md-2 control-label">Código Solicitud:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label> Código Solicitud </mat-label>
              <input matInput type="text" [(ngModel)]="modelFilter.codigo" name="codigoSolicitud"
                maxlength="10" />
            </mat-form-field>
          </div>

          <label class="col-md-2 control-label">Solicitante:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label> Solicitante </mat-label>
              <input matInput type="text" placeholder="Solicitante" [(ngModel)]="modelFilter.solicitante"
                name="solicitante" maxlength="40" />
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="form-horizontal">
        <div class="form-group">
          <label class="col-md-2 control-label">Empresa:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label> Empresa </mat-label>
              <input matInput type="text" placeholder="Empresa" [(ngModel)]="modelFilter.contratista" name="contratista"
                maxlength="40" />
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>

    <!-- RESULTADOS -->
    <div class="block-content">
      <div class="form-horizontal">
        <div class="form-group">
          <div class="col-sm-6 text-left">
            <button class="btn btn-naranja" mat-raised-button (click)="registrarResultados()" [disabled]="esInvalido()">
              <mat-icon>send</mat-icon> Enviar
            </button>
            <a class="btn btn-celeste" mat-raised-button (click)="export()"><mat-icon>table_chart</mat-icon>
              Exportar</a>
          </div>
          <div class="col-sm-6 text-right">
            <a class="btn btn-cyan" mat-raised-button (click)="search()"><mat-icon>search</mat-icon> Buscar</a>

          </div>
        </div>
      </div>

      <div class="table-responsive">
        <table mat-table [dataSource]="modelListaSolicitudes" class="table table-striped table-vcenter">
          <ng-container matColumnDef="codigo">
            <th mat-header-cell *matHeaderCellDef>Código Solicitud</th>
            <td mat-cell *matCellDef="let element" class="centre">{{ element.codigo }}</td>
          </ng-container>

          <ng-container matColumnDef="compania">
            <th mat-header-cell *matHeaderCellDef>Compañía</th>
            <td mat-cell *matCellDef="let element" class="centre">{{ element.compania }}</td>
          </ng-container>

          <ng-container matColumnDef="contratista">
            <th mat-header-cell *matHeaderCellDef>Empresa</th>
            <td mat-cell *matCellDef="let element">
              {{ element.contratista }}
            </td>
          </ng-container>

          <ng-container matColumnDef="sede">
            <th mat-header-cell *matHeaderCellDef>Sede</th>
            <td mat-cell *matCellDef="let element" class="centre">{{ element.nombreSede }}</td>
          </ng-container>

          <ng-container matColumnDef="trabajo">
            <th mat-header-cell *matHeaderCellDef>Trabajo</th>
            <td mat-cell *matCellDef="let element">{{ element.trabajo }}</td>
          </ng-container>

          <ng-container matColumnDef="fechaInicio">
            <th mat-header-cell *matHeaderCellDef>Fecha Inicio</th>
            <td mat-cell *matCellDef="let element" class="centre">
              {{ element.fechaInicio | date: "dd/MM/yyyy" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="fechaFin">
            <th mat-header-cell *matHeaderCellDef>Fecha Fin</th>
            <td mat-cell *matCellDef="let element" class="centre">
              {{ element.fechaFin | date: "dd/MM/yyyy" }}
            </td>
          </ng-container>
          
          <ng-container matColumnDef="solicitante">
            <th mat-header-cell *matHeaderCellDef>Solicitante</th>
            <td mat-cell *matCellDef="let element">
              {{ element.solicitante }}
            </td>
          </ng-container>

          <ng-container matColumnDef="aprobado">
            <th mat-header-cell *matHeaderCellDef>Autorizado
              <mat-slide-toggle [(ngModel)]="checkTodosAutorizados" (change)="changeAutorizadoAll($event)">
              </mat-slide-toggle>
            </th>
            <td mat-cell *matCellDef="let element" class="centre">
              <mat-slide-toggle [(ngModel)]="element.autorizado" (change)="changeAutorizado(element)">
              </mat-slide-toggle>
            </td>
          </ng-container>

          <ng-container matColumnDef="desaprobado">
            <th mat-header-cell *matHeaderCellDef>No Autorizado
              <mat-slide-toggle [(ngModel)]="checkTodosRechazados" class="observado"
                (change)="changeRechazadoAll($event)">
              </mat-slide-toggle>

            </th>
            <td mat-cell *matCellDef="let element" class="centre">
              <mat-slide-toggle [(ngModel)]="element.rechazado" class="observado" (change)="changeRechazado(element)">
              </mat-slide-toggle>
            </td>
          </ng-container>

          <ng-container matColumnDef="acciones">
            <th mat-header-cell *matHeaderCellDef>Acciones</th>
            <td mat-cell *matCellDef="let element">              
              <button
                mat-icon-button
                color="primary"
                aria-label="Ver Detalle"
                title="Ver Detalle"
                (click)="openDialogDetalle(element)"
              >
                <mat-icon>remove_red_eye</mat-icon>
              </button>

            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
        <mat-paginator #paginator [length]="resultsLength" [pageSize]="30" (page)="getPaginatorData($event)"
          [pageSizeOptions]="[30, 50, 100]"></mat-paginator>
      </div>
    </div>
  </div>
</div>